<app-checkbox-choices
  *ngIf="option && option.choices && option.choices.length"
  [option_id]="option.option_id"
  (choicesChanged)="optionChanged($event)"
  [selectedProductCategory]="selectedProductCategory"
  [selectedProductPromo]="selectedProductPromo"
  [alt_dinein_active]="alt_dinein_active"
  [bundleMode]="bundleMode"
  [selectedProductId]="selectedProductId"
  [groupStoreData]="groupStoreData"
></app-checkbox-choices>
